import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, NgZone, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationExtras, Router, RouterModule } from '@angular/router';
import { DataProvider } from '../../../../Providers/DataProvider';
import { EncrDecrService } from '../../../../Providers/EncrDecrService';
import { CommonService } from '../../../question/services/commonservice';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { surveyDetails } from '../../models/surveyModels';
import { SurveyService } from '../../services/survey/survey.service';

@Component({
  selector: 'survey',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AgGridModule],
  templateUrl: './page-survey.component.html',
  styleUrl: './page-survey.component.scss',
  providers: [CommonService, DataProvider, EncrDecrService, SurveyService]
})
export class PageSurveyComponent implements OnInit {

  public workspaceId: string;
  public allSurveyList!: surveyDetails[];
  myAppUrl: any;
  public showCopyModal = false;
  public showDeleteModal = false;
  //public _getSurveyListUrl: string = 'Survey/GetSurveyList/';
  //public _deleteSurveyUrl: string = 'Survey/DeleteSurvey/';
  //public _copySurveyUrl: string = 'Survey/CopySurvey/';
  currentDeletingSurveyId!: number;
  currentSelectedSurveyId!: number;
  public currentSelectedSurveyName!: string;
  copySurveyForm!: FormGroup;
  successOrFailureMessage: string = '';
  constructor(private _router: Router,
    @Inject('BASE_URL') baseUrl: string,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private surveyService: SurveyService,
    private renderer: Renderer2,
    private EncrDecr: EncrDecrService,
    private _ngZone: NgZone,
    private dataProvider: DataProvider,
    private http: HttpClient,) {
    this.myAppUrl = baseUrl;
    this.workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? "");

  }

  ngOnInit() {
    this.copySurveyForm = this.formBuilder.group({
      'surveyName': new FormControl('', Validators.required),
      sourceSurveyId: 0,
      serviceLineId: 0,
      isIncludeResponses: false, // Use boolean
    });
    this.getSurveyList();
    //this.AddCopySurvey();

    //$('.loader').removeClass('is-active');
  }
  public columnDefs: ColDef[] = [
    { headerName: 'Survey Id', field: 'surveyId', hide: true },
    { headerName: 'Survey Name', field: 'surveyName', width: 550, cellStyle: { 'white-space': 'normal' }, autoHeight: true, cellRenderer: this.EditlinkRenderer.bind(this), resizable: true },
    { headerName: 'Language', field: 'language', width: 120, resizable: true },
    { headerName: 'Last Modified By', field: 'modifiedBy', resizable: true },
    { headerName: 'Last Modified Date', width: 180, field: 'modifiedDate', cellRenderer: (data: any) => { return data.value ? (new Date(data.value)).toLocaleDateString() : ''; }, resizable: true },
    { headerName: 'Copy', width: 100, cellRenderer: this.copyImageRenderer.bind(this), resizable: true },
    { headerName: 'Preview', width: 100, cellRenderer: this.previewImageRenderer.bind(this), resizable: true },
    { headerName: 'Delete', width: 100, cellRenderer: this.deleteImageRenderer.bind(this), resizable: true },
    { headerName: 'Configure', width: 160, cellRenderer: this.AdaptiveAssessmentSettingsRenderer.bind(this) }
  ];

  linkRenderer(params: any) {
  }
  deleteImageRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    element.setAttribute('data-toggle', 'modal');
    //element.setAttribute('href', '#deleteSurveyModelConfirmation');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);

    this.renderer.listen(element, 'click', () => {
      this.showDeleteModal = true;
      this.currentDeletingSurveyId = params.data.surveyId
    });
    return element;
  }

  AddCopySurvey() {
    this.copySurveyForm.patchValue({
      surveyName: '',
      sourceSurveyId: 0,
      serviceLineId: 0,
      isIncludeResponses: false, // Use boolean
    });
  }
  CopySurvey() {
    this.surveyService.copySurvey(this.copySurveyForm.value).subscribe(result => {
      this.allSurveyList = result.surveyList;
      if (result.status == 'Yes') {
        this.successOrFailureMessage = "Survey has been copied successfully.";
      }
      else {
        this.successOrFailureMessage = "Error occurred while trying to copy the specified survey.Please try again..";
      }
      this.messageTimeout();
      this.copySurveyForm.reset();
      this.showCopyModal = false;
    },
      error => console.error(error));
  }
  closeModal() {
    this.showCopyModal = false;
    this.showDeleteModal = false;
  }
  copyImageRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    element.setAttribute('data-toggle', 'modal');
    //element.setAttribute('href', '#copySurveyModel');
    elementI.setAttribute('class', 'fa  fa-copy anchor-cursor');
    this.renderer.appendChild(element, elementI);

    this.renderer.listen(element, 'click', () => {
      this.showCopyModal = true;
      this.currentSelectedSurveyId = params.data.surveyId;
      this.currentSelectedSurveyName = params.data.surveyName;


      this.copySurveyForm.patchValue({
        sourceSurveyId: params.data.surveyId,
        serviceLineId: -1,
        surveyName: 'Copy of ' + params.data.surveyName,
        isIncludeResponses: false, // Use boolean
      });
    });
    return element;
  }
  previewImageRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-eye anchor-cursor');
    this.renderer.appendChild(element, elementI);

    this.renderer.listen(element, 'click', () => {
      /*this.currentDeletingSurveyId = params.data.surveyId*/
      localStorage.setItem('fromModule', "Survey");
      let navigationExtras: NavigationExtras = {
        queryParams: { 'surveyId': params.data.surveyId, 'companyId': -1, 'serviceLineId': -1, 'isPreview': true }
      };
      this._ngZone.run(() => {
        this.dataProvider.data = {
          "surveyId": params.data.surveyId,
          "companyId": params.data.companyId,
          "serviceLineId": params.data.serviceLineId,
          "isPreview": true
        }

        this._router.navigate(['./survey-preview']);
      });
      // Navigate to the login page with extras
      //this._router.navigate(['/survey-preview'], navigationExtras);
    });
    return element;
  }
  AdaptiveAssessmentSettingsRenderer(params: any) {

    const mainElement = this.renderer.createElement('div');
    this.renderer.setStyle(mainElement, 'justify', 'content: center');

    //Adaptive assessment settings renderer
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-gear anchor-cursor p-2');
    elementI.setAttribute('title', 'Adaptive Assessment Settings');
    this.renderer.appendChild(element, elementI);
    this.renderer.appendChild(mainElement, element);

    //Cascade Question Settings
    const cascadeAnchor = this.renderer.createElement('a');
    const cascadeIcon = this.renderer.createElement('i');
    cascadeIcon.setAttribute('class', 'fa fa-wrench anchor-cursor p-2');
    cascadeIcon.setAttribute('title', 'Cascade Question Settings');
    this.renderer.appendChild(cascadeAnchor, cascadeIcon);
    this.renderer.appendChild(mainElement, cascadeAnchor);

    //Question Option And Section Settings
    const qAnchor = this.renderer.createElement('a');
    const qIcon = this.renderer.createElement('i');
    qIcon.setAttribute('class', 'fa fa-cogs anchor-cursor p-2');
    qIcon.setAttribute('title', 'Question Option And Section Settings');
    this.renderer.appendChild(qAnchor, qIcon);
    this.renderer.appendChild(mainElement, qAnchor);


    //Merge Code Question Settings
    const mergeAnchor = this.renderer.createElement('a');
    const mergeIcon = this.renderer.createElement('i');
    mergeIcon.setAttribute('class', 'fa fa-code-fork anchor-cursor p-2');
    mergeIcon.setAttribute('title', 'Merge Code Question Settings');
    this.renderer.appendChild(mergeAnchor, mergeIcon);
    this.renderer.appendChild(mainElement, mergeAnchor);

    //Matrix Question Conditional Settings
    const matrixConditionalAnchor = this.renderer.createElement('a');
    const matrixConditionalIcon = this.renderer.createElement('i');
    matrixConditionalIcon.setAttribute('class', 'fa fa-cogs anchor-cursor p-2');
    matrixConditionalIcon.setAttribute('title', 'Matrix Conditional Settings');
    this.renderer.appendChild(matrixConditionalAnchor, matrixConditionalIcon);
    this.renderer.appendChild(mainElement, matrixConditionalAnchor);


    this.renderer.listen(qAnchor, 'click', () => {
      localStorage.setItem('fromModule', "Survey");
      let navigationExtras: NavigationExtras = {
        queryParams: { 'surveyId': params.data.surveyId, 'companyId': -1, 'serviceLineId': -1 }
      };
      this._ngZone.run(() => {
        this.dataProvider.data = {
          "surveyId": params.data.surveyId
        }
        localStorage.setItem("surveyId", this.EncrDecr.set(params.data.surveyId));
        this._router.navigate(['./questionOptionSectionSettings']);
      });
    });

    this.renderer.listen(cascadeAnchor, 'click', () => {
      localStorage.setItem('fromModule', "Survey");
      let navigationExtras: NavigationExtras = {
        queryParams: { 'surveyId': params.data.surveyId, 'companyId': -1, 'serviceLineId': -1 }
      };
      this._ngZone.run(() => {
        this.dataProvider.data = {
          "surveyId": params.data.surveyId
        }
        localStorage.setItem("surveyId", this.EncrDecr.set(params.data.surveyId));
        this._router.navigate(['./cascadingQuestionSettings']);
      });
    });

    this.renderer.listen(mergeAnchor, 'click', () => {
      localStorage.setItem('fromModule', "Survey");
      let navigationExtras: NavigationExtras = {
        queryParams: { 'surveyId': params.data.surveyId, 'companyId': -1, 'serviceLineId': -1 }
      };
      this._ngZone.run(() => {
        this.dataProvider.data = {
          "surveyId": params.data.surveyId
        }
        localStorage.setItem("surveyId", this.EncrDecr.set(params.data.surveyId));
        this._router.navigate(['./mergeCodeQuestionSettings']);
      });
    });

    this.renderer.listen(element, 'click', () => {
      /*this.currentDeletingSurveyId = params.data.surveyId*/
      localStorage.setItem('fromModule', "Survey");
      let navigationExtras: NavigationExtras = {
        queryParams: { 'surveyId': params.data.surveyId, 'companyId': -1, 'serviceLineId': -1 }
      };
      this._ngZone.run(() => {
        this.dataProvider.data = {
          "surveyId": params.data.surveyId
        }
        localStorage.setItem("surveyId", this.EncrDecr.set(params.data.surveyId));
        this._router.navigate(['./adaptiveassessment']);
      });
      // Navigate to the login page with extras
      //this._router.navigate(['/survey-preview'], navigationExtras);
    });


    this.renderer.listen(matrixConditionalAnchor, 'click', () => {
      localStorage.setItem('fromModule', 'Survey');
      let navigationExtras: NavigationExtras = {
        queryParams: { 'surveyId': params.data.surveyId, 'companyId': -1, 'serviceLineId': -1 }
      };
      this._ngZone.run(() => {
        this.dataProvider.data = {
          "surveyId": params.data.surveyId
        }
        localStorage.setItem("surveyId", this.EncrDecr.set(params.data.surveyId));
        this._router.navigate(['./matrixconditionalsetting']);
      });

    });


    return mainElement;
  }
  EditlinkRenderer(params: any) {
    //debugger;
    const element = this.renderer.createElement('a');
    const text = this.renderer.createText(params.data.surveyName);
    this.renderer.setAttribute(element, 'class', "anchor-cursor");
    this.renderer.appendChild(element, text);

    var surveyId = params.data.surveyId;
    this.renderer.listen(element, 'click', () => {
      this._router.navigate(['../survey-configuration'], { queryParams: { 'surveyId': surveyId } });
    });
    return element;
  }
  redirectMenu(surveyId: any) {
    this._router.navigate(['../survey-configuration'], { queryParams: { 'surveyId': surveyId } });
  }
  redirectOwnwerMenu(bulkTransfer: any) {
    this._router.navigate(['../surveyowner'], { queryParams: { 'bulkTransfer': bulkTransfer } });
  }
  getSurveyList() {
    this.surveyService.getSurveyList().subscribe(result => {
      this.allSurveyList = result;
    }, error => console.error(error));
  }

  onRowChecked(params: any) {
  }
  deleteSurvey() {
    this.surveyService.deleteSurvey(this.currentDeletingSurveyId.toString()).subscribe(result => {
      this.allSurveyList = result.surveyList;
      if (result.status == 'Success') {
        this.successOrFailureMessage = "Survey has been deleted successfully from the repository.";
      }
      else if (result.status == 'Fail') {
        this.successOrFailureMessage = "Error occurred while trying to delete the specified survey.Please try again..";
      }
      this.showDeleteModal = false;
      this.messageTimeout();
    }, error => console.error(error));
  }
  messageTimeout() {
    window.setTimeout(() => {
      this.successOrFailureMessage = '';
    }, 3200);
  }
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }

}


